import { InscripcionesAdapters } from "../adapters/inscripciones.adapters"
import { useIntegraWeb } from "./noticias.services"

/**
 * Servei d'inscripcions del WS d'Activitats (adminactivitats).
 *
 * Igual que notícies, activitats i cursos, és un servei EXTERN a la API del
 * backoffice: es crida amb `fetch` des del fetcher compartit `useIntegraWeb` i la
 * resposta es normalitza amb `InscripcionesAdapters`.
 *
 * URL: {REACT_APP_WEB_SERVICE_ACTIVIDADES}/integraWeb.php?accion=...
 */
const InscripcionesServices = {

    LISTAR_INSCRIPCIONES: function () {

        return useIntegraWeb(InscripcionesAdapters.LISTAR_INSCRIPCIONES)
    },

    LISTAR_INSCRIPCIONES_PERSONAS: function () {

        return useIntegraWeb(InscripcionesAdapters.LISTAR_INSCRIPCIONES_PERSONAS)
    },

    GET_ESTADOS_INSCRIPCION: function () {

        return useIntegraWeb(InscripcionesAdapters.GET_ESTADOS_INSCRIPCION)
    },
}

export {
    InscripcionesServices
}